/**
 * Composes two event handlers into a single function.
 * @link https://design.loke.global/?path=/docs/lib-compose-events-readme--docs
 */
function composeEventHandlers<E>(
  originalEventHandler?: (event: E) => void,
  ourEventHandler?: (event: E) => void,
) {
  return function handleEvent(event: E): void {
    originalEventHandler?.(event);

    if (!(event as unknown as Event).defaultPrevented) {
      ourEventHandler?.(event);
    }
  };
}

export { composeEventHandlers };
